export const UPDATE_SHOW_FILTER_TRAY_ACTION = 'UPDATE_SHOW_FILTER_TRAY';
